import { setArchivedListFailed, setArchivedListPending, setArchivedListSucceed } from './actions';
import { IArchivedListRequest } from './types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { fetchArchivedChats } from '../../services';
import { TChatInListSchema, CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { setRoute } from '../route';

/**
 * Получить список архивных чатов
 */
export const getArchivedChats =
  ({ timestampArchive }: IArchivedListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setArchivedListPending({ timestampArchive }));

    const archivedChats = await fetchArchivedChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestampArchive,
        subAgentRealtyUserId,
      },
    });

    if (!archivedChats) {
      dispatch(setArchivedListFailed());

      return;
    }

    const archivedChatsVisible = chatList.chats
      .filter((chat: TChatInListSchema) => chat.archived)
      .concat(archivedChats);

    dispatch(setArchivedListSucceed(archivedChatsVisible.length ? archivedChats : []));

    /**
     * Ставим активный пункт меню - спам и сбрасываем восстановленный id из архива,
     * чтобы обнулить открытый чат при переходе в архив.
     */
    dispatch(
      setRoute({ route: ERoute.Archive, cleanRemovedFromArchiveChatId: true, cleanRemovedFromSpamChatId: true }),
    );
  };
